import { render, staticRenderFns } from "./DialogHost.vue?vue&type=template&id=65daa239&scoped=true"
import script from "./DialogHost.vue?vue&type=script&lang=js"
export * from "./DialogHost.vue?vue&type=script&lang=js"
import style0 from "./DialogHost.vue?vue&type=style&index=0&id=65daa239&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65daa239",
  null
  
)

export default component.exports